import {createApp} from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import {ElTable} from 'element-plus'
import 'element-plus/dist/index.css'
import show from './views/Place.vue'
const app = createApp(App)
app.use(store)
app.use(router)
app.use(ViewUIPlus)
app.mount('#app')
app.use(ElTable)
app.use(show)
